import angular from 'angular';
import MediaPickerModal from '../MediaPickerModal/MediaPickerModal';

export default angular.module('cms.creator.media.picker.modal.service', [MediaPickerModal])
    .factory('MediaPickerModalService', function (MediaPickerModal) {

        let open = (model, multiple = false) => MediaPickerModal.open(multiple).result.then(selectedMedia => {
            selectedMedia.forEach((el) => {
                let exists = model.filter(existing => {
                    return existing.media.id === el.id;
                }).length >= 1;

                if (!exists) {
                    if (multiple) {
                        model.push({
                            media: angular.copy(el)
                        });
                    } else {
                        model = [{media: angular.copy(el)}];
                    }
                }
            });
            return new Promise(resolve => resolve(model));
        });

        return {
            open: open
        };

    })
    .name


// WEBPACK FOOTER //
// ./src/cmsCore/MediaModules/MediaPickerModalService/MediaPickerModalService.js